import React, { useState, useEffect, useRef } from "react";
import { Backdrop, CircularProgress, Tooltip } from "@mui/material";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import SideNavigation from "./components/SideNavigation";
import LoginHeader from "./components/LoginHeader";
import LeftContainer from "./LeftContainer";
import RightContainer from "./RightContainer";
import getQuestionData from "./getQuestionData";
import tabData from "./tabData"; // Import tabData
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import WestIcon from "@mui/icons-material/West";
import EastIcon from "@mui/icons-material/East";
import InputPopup from "./InputPopup";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { BlobServiceClient } from "@azure/storage-blob";
import { useNavigate } from "react-router-dom";
import AADHeader from "./components/AADHeader.js";

const steps = ["Start", "Materiality", "Module", "Input", "Report"];

export default function GenerateReport() {
  const companyid = localStorage.getItem("companyid");
  const username = localStorage.getItem("userName");
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768);
  const [isModalOpen, setIsModalOpen] = useState(() => localStorage.getItem("popup3") === "true");
  const [loading, setLoading] = React.useState(false);
  const [selectedContent, setSelectedContent] = useState("");
  const [selectedLabel, setSelectedLabel] = useState("");
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [repoStatus, setRepoStatus] = useState({ ready: 0, processing: 0, total: 0, allReady: true });
  const rightContainerRef = useRef(null);

  const checkRepositoryStatus = async () => {
    const report_name = localStorage.getItem("report_name");
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}list-repository-new`, {
        method: "POST",
        headers: { "Content-type": "application/json; charset=UTF-8", username },
        body: JSON.stringify({ company_id: companyid, report_name }),
      });
      if (response.ok) {
        const data = await response.json();
        const trainingStatus = data.training_status || {};
        let ready = 0, processing = 0, total = 0;
        Object.values(trainingStatus).forEach((s) => {
          total++;
          if (s.vector_upload_status === "completed" || s.vector_upload_status === "complete") ready++;
          else if (s.vector_upload_status !== "error") processing++;
        });
        const status = { ready, processing, total, allReady: processing === 0 };
        setRepoStatus(status);
        return status;
      }
    } catch (error) {
      console.error("Error checking repository status:", error);
    }
    const defaultStatus = { ready: 0, processing: 0, total: 0, allReady: true };
    setRepoStatus(defaultStatus);
    return defaultStatus;
  };
  const questionData = getQuestionData();
  const step1 = localStorage.getItem("step1");
  const stept3 = localStorage.getItem("step3");
  const reportName = JSON.parse(step1);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsSidebarOpen(false); // Close sidebar on mobile
      } else {
        setIsSidebarOpen(true); // Open sidebar on larger screens
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  async function uploadJsonFile(containerName, folderName, fileName, jsonData) {
    try {
      // Fetch SAS token from your API
      let res = await fetch(`${process.env.REACT_APP_BASE_API_URL}GetSASToken`, {
        method: "GET",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      });

      if (res.status === 200) {
        const responseJson = await res.json();
        const connectionString = responseJson.data;

        // Create BlobServiceClient using the SAS token
        const blobServiceClient = new BlobServiceClient(connectionString);

        // Get or create container
        const containerClient = blobServiceClient.getContainerClient(containerName);

        //await containerClient.createIfNotExists();

        // Get BlobClient for the file
        const blobName = `${folderName}/${fileName}.json`; // Construct blob name with folder path
        const blobClient = containerClient.getBlobClient(blobName);
        const blockBlobClient = blobClient.getBlockBlobClient();
        console.log(blobClient);
        // Convert JSON data to ArrayBuffer
        const arrayBuffer = new TextEncoder().encode(JSON.stringify(jsonData));
        // Upload the file content
        const uploadResponse = await blockBlobClient.uploadBrowserData(arrayBuffer.buffer, {
          blobHTTPHeaders: { blobContentType: "application/json" }, // Set content type as JSON
          blockSize: 4 * 1024 * 1024, // 4MB block size
          concurrency: 20, // Number of concurrent requests
          onProgress: (ev) => console.log(ev.loadedBytes),
        });
        if (uploadResponse) {
          console.log(`JSON file "${fileName}" uploaded successfully.`);
          console.log(`Blob URL: ${blobClient.url}`);
          localStorage.setItem("bloburl", blobClient.url);
        }
        // Perform any additional operations after successful upload
        // uploadFileName(fileName); // Assuming this is some function you want to call after upload
      } else {
        console.error("Failed to fetch SAS token.");
      }
    } catch (error) {
      console.error("Error uploading JSON file:", error);
    }
  }

  const handleNext = () => {
    rightContainerRef.current?.saveCurrentSectionTables?.();
    const step1 = localStorage.getItem("step1");
    const step2 = localStorage.getItem("step2");
    const step3 = localStorage.getItem("step3");
    const step4 = JSON.parse(localStorage.getItem("step4")) || [];
    const hash = localStorage.getItem("hash");
    const organizationValue = localStorage.getItem("organization");
    const selectedOptions = localStorage.getItem("selectedOptions");
    let mdrp = [];
    if (selectedOptions !== null && selectedOptions !== "") {
      mdrp = JSON.parse(selectedOptions) || [];
    } else {
      mdrp = [];
    }
    const username = localStorage.getItem("userName");
    // De-duplicate by question, keeping the latest saved value (important when user re-saves a table).
    const uniqueMap = new Map();
    for (let i = step4.length - 1; i >= 0; i--) {
      const item = step4[i];
      const key = item?.id ?? (typeof item?.question === "string" ? item.question.trim() : item?.question);
      if (key == null) continue;
      if (!uniqueMap.has(key)) uniqueMap.set(key, item);
    }
    const uniqueData = Array.from(uniqueMap.values()).reverse();
    console.log(uniqueData);
    localStorage.setItem("step4", JSON.stringify(uniqueData));
    const answers = localStorage.getItem("answers");
    const answers1 = localStorage.getItem("answers1");
    const tableanswers = localStorage.getItem("tableAnswers");
    const selectedOptions1 = localStorage.getItem("selectedOptions");
    const parseData = JSON.parse(step1);
    const rdata = {
      name: parseData.name,
      timeline: parseData.timeline,
      legalEntity: parseData.legalEntity,
      startDate: parseData.startDate,
      endDate: parseData.endDate,
      materiality: JSON.parse(step2),
      reportingModule: JSON.parse(step3),
      generateReport: uniqueData,
      mdrp: mdrp,
      answers: JSON.parse(answers),
      answers1: JSON.parse(answers1),
      tableAnswers: JSON.parse(tableanswers),
      selectedOptions: JSON.parse(selectedOptions1),
    };
    uploadJsonFile("ecoprismfilecontainer", companyid, hash, rdata);

    navigate("/PreviewReport");
  };

  const prepareStatusDashboardContext = () => {
    const step1 = localStorage.getItem("step1");
    if (!step1) return;
    const parsed = JSON.parse(step1);
    const reportName = parsed?.name || "Untitled Report";
    const completionDate = parsed?.timeline1 || parsed?.timeline || "";
    localStorage.setItem("reportStatusData", JSON.stringify({ reportName, completionDate }));
    const hash = localStorage.getItem("hash") || "";
    const statusFile = hash ? `${hash}.json` : "";
    localStorage.setItem("statusReportFile", statusFile);
    localStorage.setItem("statusDashboardUrl", `/reportdashboard?file=${encodeURIComponent(statusFile)}`);
  };

  useEffect(() => {
    let pollInterval = null;
    const startPolling = async () => {
      const status = await checkRepositoryStatus();
      if (!status.allReady && status.processing > 0) {
        pollInterval = setInterval(async () => {
          const next = await checkRepositoryStatus();
          if (next.allReady) { clearInterval(pollInterval); pollInterval = null; }
        }, 5000);
      }
    };
    startPolling();
    return () => { if (pollInterval) clearInterval(pollInterval); };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // Retrieve and parse the selected data from URL parameters
    const searchParams = new URLSearchParams(window.location.search);
    const selectedDataString = searchParams.get("selectedData");
    if (selectedDataString) {
      const selectedData = JSON.parse(decodeURIComponent(selectedDataString));
      // Extract and store the selected checkboxes
      const checkboxes = selectedData
        .flatMap((tab) =>
          tab.selectedCheckboxes.map((checkbox) => ({
            id: checkbox.id,
            label: checkbox.label,
            tooltip: checkbox.tooltip,
          })),
        )
        .filter((checkbox) => checkbox.id !== undefined);
      setSelectedCheckboxes(checkboxes);
    }
    //setIsModalOpen(true);
  }, []);

  // Function to update selected content when a tab is clicked
  const handleSelect = (content, label) => {
    setSelectedContent(content);
    setSelectedLabel(label); // Store the label name in state
  };
  const renderHeader = () => {
    const loginType = localStorage.getItem("loginType");
    if (loginType === "AAD") {
      return <AADHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />;
    }
    return <LoginHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />;
  };
  return (
    <div id="wrapper">
      <InputPopup isModalOpen={isModalOpen} onClose={closeModal} />
      <div>
        {loading && (
          <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
      </div>
      {renderHeader()}
      <SideNavigation isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div id="page-content-wrapper" className={isSidebarOpen ? "page-content-wrapper-pd-0" : "page-wrapper"}>
        <div className="container formpd bg-grey">
          {/* Title and Breadcrumbs */}
          <div className="">
            <div className="row">
              <div className="steps__containt-hader col-md-6">
                <h3 className="title">{reportName.name}</h3>
                <div role="presentation">
                  <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                    <Link underline="hover" color="inherit" href="/standards">
                      Reports
                    </Link>
                    <Link underline="hover" color="inherit" href="/standards">
                      Standards & Frameworks
                    </Link>
                    <Link underline="hover" color="inherit" href="/csrd">
                      CSRD
                    </Link>
                    <Typography color="text.primary">{reportName.name}</Typography>
                  </Breadcrumbs>
                </div>
              </div>
              <div className="stepper-box col-md-6">
                <Stepper activeStep={3} alternativeLabel className="csrd-stepper">
                  {steps.map((label) => (
                    <Step key={label}>
                      <StepLabel className="step-name">{label}</StepLabel>
                    </Step>
                  ))}
                </Stepper>
              </div>
            </div>
          </div>
          <div className="button-box d-flex justify-content-end">
            <Tooltip title={!repoStatus.allReady && repoStatus.processing > 0 ? `${repoStatus.processing} file(s) still analyzing. ${repoStatus.ready} of ${repoStatus.total} ready.` : ""}>
              <span>
                <Button
                  onClick={() => rightContainerRef.current?.triggerGenerateAI()}
                  variant="outlined"
                  className="module-btn"
                  size="medium"
                  sx={{ marginRight: "15px" }}
                  disabled={!repoStatus.allReady && repoStatus.processing > 0}
                >
                  Generate with AI
                </Button>
              </span>
            </Tooltip>
            <Button onClick={() => navigate("/ReportingModules")} variant="outlined" className="module-btn" size="medium" sx={{ marginRight: "15px" }}>
              <WestIcon fontSize="small" sx={{ marginRight: "4px" }} />
              Module
            </Button>
            <Button onClick={prepareStatusDashboardContext} variant="outlined" className="module-btn" size="medium" sx={{ marginRight: "15px" }} disabled>
              <img src="/assets/img/reports/Status.svg" style={{ marginRight: "4px" }} />
              Status
            </Button>
            <Button onClick={() => navigate("/PreviewReport")} variant="outlined" className="module-btn" size="medium">
              Preview Report
              <EastIcon fontSize="small" sx={{ marginLeft: "4px" }} />
            </Button>
          </div>

          <div className="input-page-container">
            <div className="left-container" style={{ flex: "33%" }}>
              <LeftContainer onSelect={handleSelect} selectedCheckboxes={selectedCheckboxes} />
            </div>
            <div className="right-container" style={{ flex: "67%" }}>
              {/* <RightContainer
                selectedContent={selectedContent}
                questions={questionData[selectedContent]}
                selectedLabel={selectedLabel} // Pass the selected label as a prop
              /> */}
              <RightContainer ref={rightContainerRef} selectedContent={selectedContent} questions={questionData[selectedContent]} selectedLabel={selectedLabel} tabData={tabData} />
            </div>
          </div>
          <div className="buttons-container">
            <Button onClick={() => navigate("/ReportingModules")} variant="outlined" className="outline-btn" size="medium" type="button">
              <ChevronLeftIcon fontSize="small" /> Previous
            </Button>
            <Button className="next-button" onClick={handleNext} variant="contained" size="medium">
              Next
              <ChevronRightIcon fontSize="small" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
